import styled from '@emotion/styled'
import { ReactNode } from 'react'

import { Color, theme } from '../../../../constants'
import { useSchedule } from '../useSchedule'

const Table = styled.table<{
  isMultipleWeeks: boolean
  headerColumnWidth: number
  columnWidth: number
  columnCount: number
}>`
  line-height: ${theme.lineHeight.normal};
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
  height: 0;
  border-bottom: 1px solid ${Color.GREY};
  background-color: ${Color.WHITE};

  width: ${(props) =>
    props.isMultipleWeeks
      ? `${props.headerColumnWidth + props.columnCount * props.columnWidth}px` // Total width = fixed column + day columns: ;
      : '100%'};

  col:first-of-type {
    width: ${(props) =>
      props.headerColumnWidth}px; // Fixed width for the first column
  }

  ${(props) =>
    props.isMultipleWeeks &&
    `
    col:not(:first-of-type) {
      width: ${props.columnWidth}px; // Fixed width for day columns when multiple weeks
    }
  `}

  td {
    padding: 4px;
    vertical-align: top;
  }
`

export const Grid = (props: { children: ReactNode }) => {
  const { days, headerColumnWidth, columnWidth, columnCount } = useSchedule()

  return (
    <Table
      isMultipleWeeks={days.length > 7}
      columnCount={columnCount}
      headerColumnWidth={headerColumnWidth}
      columnWidth={columnWidth}
    >
      {props.children}
    </Table>
  )
}
